import type { Medical } from '~entities/student/modal/medical';

const MEDICAL_FIELD_LABELS: Record<keyof Medical, string> = {
  primaryDoctor: 'Primary Doctor',
  medications: 'Medications',
  allergies: 'Allergies',
  disabilities: 'Disabilities',
  specialNeeds: 'Special Needs',
  healthInsuranceCarrier: 'Health Insurance',
};

export function buildMedicalSummary(
  medical: Medical,
): Array<{ label: string; value: string }> {
  return (Object.entries(MEDICAL_FIELD_LABELS) as Array<[keyof Medical, string]>)
    .map(([fieldKey, label]) => ({
      label,
      value: (medical[fieldKey] ?? '').trim(),
    }))
    .filter((item) => item.value !== '');
}

export function hasMedicalData(medical: Medical): boolean {
  return buildMedicalSummary(medical).length > 0;
}
